import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  list: [],
  purchasePrice: {},
  total: 0
}

// getters
export const getters = {
  list: state => state.list,
  purchasePrice: state => state.purchasePrice

}

// mutations
export const mutations = {
  LIST (state, data) {
    state.list = data
  },

  PURCHASE_PRICE (state, data) {
    state.purchasePrice = data
  }
}

// actions
export const actions = {
  async fetchByFilters ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('pp_filter', { companyAbbr: store.getters['auth/company'], ...filterData }))
    commit('LIST', data.items)
  },
  async update ({ commit }, items) {
    await axios.patch(laroute.route('pp_update', { companyAbbr: store.getters['auth/company'] }), { items })
  },
  async save ({ commit }, items) {
    await axios.post(laroute.route('pp_create_many', { companyAbbr: store.getters['auth/company'] }), { items })
  },
  async reset ({ commit }) {
    commit('LIST', [])
  },
  async deleteItem ({ commit }, itemId) {
    await axios.delete(laroute.route('pp_delete', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async getOne ({ commit }, { itemMasterId, partnerId }) {
    const { data } = await axios.get(laroute.route('get-purchase-price', { itemMasterId, partnerId }))

    commit('PURCHASE_PRICE', data)
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/purchasePrice.js